// Login now runs server-side (backend /auth/login + HttpOnly session cookie),
// so there is no MSAL configuration in the browser any more. Only the static
// Azure role/resource identifiers the UI still uses are kept here.

/**
 * Service principal object ID associated to the application, this is used to filer queries in MSGraph
 * @type {string}
 */

export const resourceId = "f807e863-d866-4d95-9a5c-bf8db7b45d55";

/**
 * Map containing the available roles in the application and their IDs in Azure
 * The order in which the roles are inserted is important for later use
 * @type {Map<string, string>}
 */
export const appRoleMap = new Map([
  ["8c47c7ae-e07f-4817-ac3a-ffdd8dc14bb3", "IM"],
  ["2a84bd8d-25de-4295-b7fc-45b04cc4d833", "NRE"],
  ["cb5ade0e-c1ad-4246-a9c7-adcb7879ddff", "RRU"],
]);
